<app-generic-search
  placeholder="Buscá por Nombre, Apellido, Razón Social o email"
  (searchChange)="onSearchChange($event)"
  [initialValue]="searchQuery"
/>
